import { MergeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Merge')
export class MergeNodeSchemaProvider extends SchemaProvider<MergeWorkflowNode> {}
